import React, { useEffect, useRef } from 'react';

import type { ObserverOptions } from '../../types.js';

const ViewportChecker = ({ children }: { children: React.ReactNode }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const options: ObserverOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (containerRef.current) {
        containerRef.current.classList.toggle('active', entry.isIntersecting);
        containerRef.current.classList.toggle('idle', !entry.isIntersecting);
      }
    }, options);

    containerRef.current && observer.observe(containerRef.current);

    // Clean up the observer when the component unmounts
    return () => observer.disconnect();
  }, []);

  return <div ref={containerRef}>{children}</div>;
};

export default ViewportChecker;
